module.exports = __webpack_public_path__ + "img/rules_15.5158b59b.png";